import session from '../../auth_api/session'

const URL = process.env.VUE_APP_API_URL
const appURL = URL + 'gis_gmp/api/'

export default {
  namespaced: true,
  state: {
    discounts: [],
    listKBK: { 'results': [] }
  },
  mutations: {
    setDiscount (state, payload) {
      state.discounts = payload
    },
    setListKBK (state, payload) {
      state.listKBK = payload
    },
    update_insert_KBK (state, payload) {
      let data = state.listKBK.results
      let index = data.findIndex(kbk => kbk.id === payload.id)
      if (index >= 0) { data.splice(index, 1, payload) } else { data.splice(0, 0, payload) }
    },
    delete_KBK (state, payload) {
      let data = state.listKBK.results
      // Ищем в масиве нужный элемент по полю 'id'
      let index = data.findIndex(kbk => kbk.id === payload)
      data.splice(index, 1)
    }
  },
  actions: {
    fetchListDiscount ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpFetchDiscount'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = URL + 'gis_gmp/api/discount/'
        session.get(_url)
          .then(response => {
            commit('setDiscount', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchListKBK ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpListKBK'
        // commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = {}
        if ((0 + payload.pageId) > 1) {
          params['page'] = payload.pageId
        }
        if (payload.search > '') {
          params['search'] = payload.search
        }
        let _url = appURL + 'kbk/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setListKBK', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    insertKBK ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpInsertKBK_' + payload.id
        // commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        const data = new FormData()
        data.append('name', payload.name)
        data.append('caption', payload.caption)
        data.append('koap_item', payload.koap_item)
        data.append('discount_fixed_value', payload.discount_fixed_value)
        data.append('discount_fixed_expiry_days', payload.discount_fixed_expiry_days)
        data.append('discount_sice_value', payload.discount_sice_value)
        data.append('discount_sice_expiry_days', payload.discount_sice_expiry_days)
        data.append('multiplier_size_value', payload.multiplier_size_value)
        data.append('multiplier_size_expiry_days', payload.multiplier_size_expiry_days)

        if (payload.discount) {
          data.append('discount', payload.discount)
        } else {
          data.append('discount', '')
        }
        if (payload.date_start) {
          data.append('date_start', payload.date_start)
        }
        if (payload.date_finish) {
          data.append('date_finish', payload.date_finish)
        }
        let _url, method
        if (payload.id === null) {
          _url = appURL + 'kbk/'
          method = 'post'
        } else {
          _url = appURL + 'kbk/' + payload.id + '/'
          method = 'put'
        }

        session({ method: method, url: _url, data: data, headers: { 'Content-Type': 'multipart/form-data' } }
        )
          .then(response => {
            commit('update_insert_KBK', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    deleteKBK ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpDeleteKBK_' + payload
        // commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'kbk/' + payload + '/delete/'
        session.get(_url)
          .then(() => {
            commit('delete_KBK', payload)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
    discounts (state) {
      return state.discounts
    },
    listKBK (state) {
      return state.listKBK
    }
  }
}
